import type { ReactNode, RefObject } from 'react'
import type { JobDetailPreloadQueue } from './job-detail-preload'
import { JobDetailPreloadContext } from './useAgendaJobPreload'

interface JobDetailPreloadRootProps {
  queue: JobDetailPreloadQueue
  rootRef: RefObject<HTMLDivElement | null>
  className?: string
  children: ReactNode
}

// The element whose preload targets are watched, plus the context that lets the
// tray and the month popover publish to the same queue.
export function JobDetailPreloadRoot({
  queue,
  rootRef,
  className,
  children,
}: JobDetailPreloadRootProps) {
  return (
    <JobDetailPreloadContext.Provider value={queue}>
      <div ref={rootRef} className={className}>
        {children}
      </div>
    </JobDetailPreloadContext.Provider>
  )
}
